/**
 * KITT brand mark — the metallic shield logo (transparent PNG).
 *
 * Variants:
 *   <KittLogo size={...} />                    // bare mark, no halo
 *   <KittLogo size={...} withGlow />           // soft signal-orange halo, for hero placements
 *   <KittLogo size={...} className="..." />    // additional Tailwind classes
 */
export default function KittLogo({
    size = 32,
    withGlow = false,
    className = "",
    testId = "kitt-logo",
}) {
    const dim = `${size}px`;
    return (
        <div
            data-testid={testId}
            className={`relative flex-shrink-0 inline-flex items-center justify-center ${className}`}
            style={{ width: dim, height: dim }}
            aria-label="KITT — Kitting, Inventory & Transfer Terminal"
        >
            {withGlow && (
                <div
                    aria-hidden="true"
                    className="absolute inset-[-12%] rounded-full pointer-events-none"
                    style={{
                        background:
                            "radial-gradient(circle at 50% 50%, rgba(255,106,0,0.30) 0%, rgba(255,106,0,0.06) 45%, transparent 70%)",
                        filter: "blur(2px)",
                    }}
                />
            )}
            <img
                src="/branding/kitt-logo.png"
                alt="KITT"
                draggable={false}
                className="relative w-full h-full object-contain select-none"
                style={{
                    // Subtle drop shadow integrates the metallic shield with the Jet bg.
                    filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.55))",
                }}
            />
        </div>
    );
}
